/*
 * Copyright (c) 2026. Orion Analytics. All Rights Reserved
 */

import React from 'react';
import Plot from 'react-plotly.js';

const RiskReturnChart = ({ data }) => {

  return (

    <div className="bg-white rounded-3xl p-8 shadow-sm border">

      <h2 className="text-3xl font-bold mb-2">
        Risk vs Return
      </h2>

      <p className="text-gray-500 mb-8">
        Identify high-return low-risk opportunities
      </p>


      <Plot
        data={[
          {
            x: data.map(d => d.volatility),
            y: data.map(d => d.return_3y),
            text: data.map(d => d.scheme_name),
            mode: 'markers',
            type: 'scatter',
            marker: {
              size: 12,
            }
          }
        ]}

        layout={{
          height: 500,
          title: '',
          xaxis: {
            title: 'Volatility'
          },
          yaxis: {
            title: '3Y Return (%)'
          },
          paper_bgcolor: 'white',
          plot_bgcolor: 'white'
        }}

        style={{ width: '100%' }}
      />

    </div>
  );
};

export default RiskReturnChart;
